import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StateStoreService } from '../services/state-store/state-store';

/**
 * Gates `/assessments-for-review`, the cross-customer review queue.
 *
 * `managerGuard` alone is not enough here. A delegate signs into the platform
 * org, so `isManagerOrSuperManager()` is true for them by org type — they
 * would pass that guard and land on a queue where every call 403s. What
 * actually decides the queue is `assessment_review`, now held per-org on
 * own member row (T9), which a grant structurally cannot carry.
 *
 * Mirrors crp-be `assessment_handler`'s `can_review_assessments`, and pairs
 * with the identical `canReviewAssessments()` gate on the sidebar entry so
 * the nav and the route agree. Unconfigured callers keep their org-type
 * answer, so nothing changes for existing platform admins.
 *
 * Readiness is guaranteed by `appReadyMatch` at the route level.
 */
export const assessmentReviewGuard: CanActivateFn = () => {
  const state = inject(StateStoreService);
  const router = inject(Router);

  // `/dashboard` rather than `/assessment`: a delegate bounced off this queue
  // has a workspace to go back to (or the empty-workspace state), whereas
  // `/assessment` is a customer-scoped surface they may not be able to reach.
  return state.canReviewAssessments() ? true : router.createUrlTree(['/dashboard']);
};
